import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChange, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { I18nTranslator } from '../../../../i18n/translate';
import { ARFertilizerType } from '../../../../models/agrorendement-common-lists.model';
import { ARFertilizerData } from '../../../../models/agrorendement-common.model';
import { ListItem } from '../../../../models/lists.model';
import { CapitalizePipe } from '../../../../pipes/capitalize.pipe';
import { ARCommonListType, ARCommonListsService } from '../../../../services/agrorendement-common-lists.service';
import { ModalService } from '../../../../services/modal.service';
import { showErrorMessage, sortingString } from '../../../../utils/utils';
import { TranslateWithPunctuationPipe, TranslatePipe } from '../../../../pipes/translate.pipe';
import { FormsModule } from '@angular/forms';

@Component({
  standalone: true,
  selector: 'ar-fertilizer-edit',
  templateUrl: 'fertilizer-edit.component.html',
  imports: [RouterLink, RouterLinkActive, RouterOutlet, CommonModule, CapitalizePipe, TranslateWithPunctuationPipe, TranslatePipe, FormsModule],
})
export class ARFertilizerEditComponent implements OnInit, OnChanges {
  @Input() fertilizerData: ARFertilizerData;
  @Input() editable: boolean = true;
  @Input() isBatch: boolean;
  @Input() cbBatchEdit: Object = {};
  @Output() change = new EventEmitter();
  @Input() required: boolean = true;

  error: any;

  fertilizerTypes: ARFertilizerType[];

  areListsFetched = false;
  requireConsoleInfo = false;
  showOtherConsoleVersion = false;

  constructor(
    private commonListService: ARCommonListsService,
    private i18nTranslator: I18nTranslator,
    private modal: ModalService,
    private router: Router,
    private route: ActivatedRoute,
  ) {}

  getLists() {
    const listTypes = [ARCommonListType.FERTILIZER_TYPES];
    return this.commonListService.getListTypes(ARCommonListType, ...listTypes);
  }

  handleLists(lists: Map<ARCommonListType, ListItem[]>) {
    // TODO meileur facon de gerer ca ?
    this.areListsFetched = true;

    this.fertilizerTypes = lists.get(ARCommonListType.FERTILIZER_TYPES).sort(sortingString('label'));
  }

  ngOnInit() {
    const obs2 = this.getLists();
    obs2.subscribe(
      (data: Map<ARCommonListType, ListItem[]>) => {
        this.handleLists(data);
        // au cas ou le orderItem ait ete sette avant
        if (this.fertilizerData) {
          this.prepareFertilizerData();
        }
      },
      (e) => this.handleGetError(e),
    );
  }

  ngOnChanges(changes: SimpleChanges) {
    const fertilizerDataChange: SimpleChange = changes['fertilizerData'];
    // au cas ou les listes ait ete recuperees avant
    if (fertilizerDataChange && fertilizerDataChange.isFirstChange()) {
      this.prepareFertilizerData();
    }
    this.change.emit(this.fertilizerData);
  }

  prepareFertilizerData() {
    if (!this.fertilizerData.fertilizerType) {
      this.fertilizerData.fertilizerType = new ARFertilizerType();
      this.fertilizerData.fertilizerType.id = null;
    }
    if (!this.fertilizerData.fertilizerConcentration) {
      // sinon erreur check undefined => null
      this.fertilizerData.fertilizerConcentration = null;
    }
  }

  handleGetError(error: any) {
    // TODO traiter mieux
    console.error(error);
    showErrorMessage(this.modal, this.i18nTranslator.translate('error.generic'));
  }
}
